import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from '../navigation/NavBar';
import Footer from '../navigation/Footer';

export default function EcosystemLayout({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-kin-black text-kin-ivory relative selection:bg-kin-gold selection:text-kin-black">
      <NavBar />
      <main className="flex-grow fade-in">
        {children}
      </main>
      <Footer />
    </div>
  );
}